import { Injectable } from '@angular/core';
import { FavouriteProductsService, AuthService, ProductService, GungFlowService } from 'gung-standard';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloFavouriteProductsService extends FavouriteProductsService {
  constructor(
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected productService: ProductService,
    protected http: HttpClient
  ) {
    super(gungFlowService, authService, productService, http);
  }

  public isFavourite(id: string): Observable<boolean> {
    if (!this.favouriteSubject) {
      this.initFavouriteProductIds();
    }
    return this.getFavourites().pipe(
      map((favourites: string[]) => {
        if (!favourites.hasOwnProperty(id)) {
          return false;
        }
        const isFavourite = favourites[id];
        return isFavourite;
      })
    );
  }
}
